module.exports = __webpack_public_path__ + "img/world-guide.d577e83c.png";